/**
 * Admin Measurements State Types
 *
 * Type definitions for the Admin Measurements state slice.
 * Loads all measurements for students who have active goals across the team.
 * Admin-only, cached, no real-time listener (measurements change infrequently
 * from an admin overview perspective).
 */

import { Observation } from 'src/app/domain/observations/types/observations.types';

/** Signal state model for the AdminObservationsState slice. */
export interface AdminMeasurementsStateModel {
  // === Data ===
  data: Observation[];

  // === Status Flags ===
  initialized: boolean;
  loading: boolean;
  error: string | null;

  // === Metadata ===
  lastUpdated: number | null;
  lastSync: number | null;
  hydratedFromCache: boolean;

  // === Context ===
  activeTeamId: string | null;
  /** The student IDs whose measurements are loaded. Derived from admin goals. */
  studentIds: string[];
}

/** Configuration required to initialize AdminObservationsState for a team. */
export interface AdminObservationsInitConfig {
  activeTeamId: string;
  /** Student IDs to load measurements for — derived from the active goals in AdminGoalsState. */
  studentIds: string[];
}

export const ADMIN_OBSERVATIONS_DEFAULTS: AdminMeasurementsStateModel = {
  data: [],
  initialized: false,
  loading: false,
  error: null,
  lastUpdated: null,
  lastSync: null,
  hydratedFromCache: false,
  activeTeamId: null,
  studentIds: [],
};
